export default __webpack_public_path__ + "images/PP.27b6cba.png";